import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OverlayProvider, ToastProvider } from '@ordr-as/umami-react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from '@sentry/react'
import Main from 'pages/Main'

const App = () => (
    <ErrorBoundary fallback={<p>Something went wrong</p>}>
        <div>
            <QueryClientProvider client={new QueryClient()}>
                <OverlayProvider>
                    <ToastProvider>
                        <Main />
                    </ToastProvider>
                </OverlayProvider>
                <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
            </QueryClientProvider>
        </div>
    </ErrorBoundary>
)

export default App
